import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer/Footer.jsx";
import Home from "./Home.jsx";
import MyNavbar from "./components/Navbar/Navbar.jsx";

// Importar Vistas
import Nosotros from "./views/Nosotros/Nosotros.jsx";
import Contacto from "./views/Contacto/Contacto.jsx";
import Chat from "./components/ChatIcon/Chat.jsx";
import DivisionT from "./views/DivisionTextil/DivisionT.jsx";
import PaqueteC from "./views/PaqueteCompleto/PaqueteC.jsx";
import PTEELAFT from "./views/PTEE-LAFT/PTEE-LAFT.jsx";
import TermAndCond from "./views/TermsAndCond/TermAndCond.jsx";
import NotFound from "./views/404/404NotFound.jsx";
import { useLanguage } from "./assets/translations/Traslations.jsx";
import PrivacyPolicy from "./views/TermsAndCond/PrivacyPolicyChatgpt.jsx";

export default function App() {
  const RoutesName = {
    es: {
      home: "/",
      about: "/nosotros",
      contact: "/contacto",
      textileDivision: "/division-textil",
      fullPackage: "/paquete-completo",
      terms: "/t-y-c",
      notFound: "*",
      pteeLaft: "/PTEE-LAFT",
    },
    en: {
      home: "/",
      about: "/about-us",
      contact: "/contact",
      textileDivision: "/textile-division",
      fullPackage: "/full-package",
      terms: "/t-y-c",
      notFound: "*",
      pteeLaft: "/PTEE-LAFT",
    },
  };
  const { language } = useLanguage(); // Obtiene el idioma actual
  const currentRoutes = RoutesName[language]; // Selecciona las rutas según el idioma



  return (
    <Router>
      <Routes>
        <Route
          path="/Politica-de-privacidad-Chat-GPT"
          element={<PrivacyPolicy />}
        />
        <Route
          path="*"
          element={
            <>
              <MyNavbar />
              <Routes>
                <Route path={currentRoutes.home} element={<Home />} />
                <Route path={currentRoutes.about} element={<Nosotros />} />
                <Route path={currentRoutes.contact} element={<Contacto />} />
                <Route path={currentRoutes.textileDivision} element={<DivisionT />} />
                <Route path={currentRoutes.fullPackage} element={<PaqueteC />} />
                <Route path={currentRoutes.terms} element={<TermAndCond />} />
                  <Route path={currentRoutes.pteeLaft} element={<PTEELAFT />} />
                <Route path={currentRoutes.notFound} element={<NotFound />} />
              </Routes>
              <Chat />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}
